/* tslint:disable */

declare var Object: any;
export interface RequisiteCostsInterface {
  "type": string;
  "amount": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class RequisiteCosts implements RequisiteCostsInterface {
  "type": string;
  "amount": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: RequisiteCostsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RequisiteCosts`.
   */
  public static getModelName() {
    return "RequisiteCosts";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RequisiteCosts for dynamic purposes.
  **/
  public static factory(data: RequisiteCostsInterface): RequisiteCosts{
    return new RequisiteCosts(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RequisiteCosts',
      plural: 'RequisiteCosts',
      path: 'RequisiteCosts',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
